import { connectionStationText } from './connection-station';
import { printerChoiceStatus } from './print-connection-view';
export const printStates: Record<string, string> = {
  QUEUED: 'Đang chờ xử lý', LEASED: 'Đang chuẩn bị', RECEIVED: 'Đã nhận yêu cầu', SENDING: 'Đang gửi tới máy in',
  SUCCEEDED: 'Hoàn tất thao tác', SENT_UNVERIFIED: 'Đã gửi tới máy in', OUTPUT_CONFIRMED: 'Đã xác nhận nhãn trên giấy',
  UNKNOWN: 'Cần kiểm tra nhãn trên giấy', FAILED: 'Không thực hiện được', EXPIRED: 'Yêu cầu hết hạn', CANCELLED: 'Đã hủy',
};
export function printTaskName(task: any) {
  const name = ({ PRINT: 'In nhãn', TEST: 'In nhãn mẫu', SCAN: 'Tìm thiết bị', PROBE: 'Kiểm tra khả năng kết nối', CONNECT: 'Kết nối thiết bị' } as Record<string, string>)[task.kind] ?? 'Thao tác thiết bị';
  return `${name}${task.kind === 'PRINT' && task.source_code ? ` ${task.source_code}` : ''}`;
}
export function unavailablePrinterMessage(printer: any) {
  const name = connectionStationText(`${printer.name} (${printer.location_name})`);
  switch (printer.reason) {
    case 'PRINTER_DISABLED': return `${name} đang tạm ngừng sử dụng. Người quản lý có thể bật lại tại Máy in.`;
    case 'GATEWAY_DISABLED': return `${name}: Trạm kết nối đang bị khóa. Liên hệ người quản lý.`;
    case 'LOCATION_DISABLED': return `${name}: khu vực này đang bị khóa. Liên hệ người quản lý.`;
    default: return `${name} cần xác nhận nhãn mẫu lần đầu hoặc sau khi đổi cấu hình.`;
  }
}
export function printerStatus(printer: any, connected: boolean) {
  if (printer.status === 'DISABLED') return 'Tạm ngừng sử dụng';
  if (printer.gateway_enabled === false) return 'Trạm kết nối bị khóa';
  if (printer.location_enabled === false) return 'Khu vực bị khóa';
  if (printer.status !== 'ACTIVE' || !printer.raster_verified) return 'Cần xác nhận nhãn mẫu';
  return connected ? printerChoiceStatus(printer) : 'Trạm kết nối mất liên lạc';
}
export function scanDescription(scan: any, now = Date.now()) {
  if (!scan) return 'Bật máy in và đặt gần Trạm kết nối, rồi bấm Tìm máy in.';
  const time = new Date(scan.created_at).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
  if (scan.state === 'SUCCEEDED') {
    if (now - Date.parse(scan.updated_at) >= 300_000) return `Lần tìm lúc ${time} đã hết hạn. Bấm Tìm lại để cập nhật.`;
    return `Tìm lúc ${time} — thấy ${scan.result?.devices?.length ?? 0} thiết bị.`;
  }
  return `Tìm lúc ${time} — ${printStates[scan.state] ?? 'Đang xử lý'}.`;
}
export function defaultPrintingLocation(data: any) {
  const enabled = (data.locations ?? []).filter((l: any) => l.enabled);
  const connected = (data.gateways ?? []).find((g: any) => g.enabled && g.last_seen && Date.now() - Date.parse(g.last_seen) < 60_000);
  const preferred = data.context?.locationId ?? connected?.location_id;
  return enabled.find((l: any) => l.id === preferred)?.id ?? enabled[0]?.id ?? '';
}
